import styles from './styles.module.scss'

import { Helmet } from 'react-helmet';

import { Button, Card} from 'antd';

export const PageEventSummerSale = () => {
  const onCartClick = (e: React.MouseEvent) => {
    alert('on cart click')
  }

  const onBuyClick = (e: React.MouseEvent) => {
    alert('on buy click')
  }

  return (
    <>
      <Helmet>
        <title>상품: 맛있는 딸기</title>
      </Helmet>
      <div className={styles.body}>
        <Card title="여름에는 딸기가 맛있어요!" headStyle={{textAlign: 'left'}}>
          <div className={styles.content}>
            <div className={styles.colLeft}>
              <a target="_blank" href="https://codepen.io/daviddarnes/pen/qOmQeB" rel="noopener noreferrer" >
                <span className={styles.sale}>-50%</span>
              </a>
              <img className={styles.thumbnail} src="/ga4/strawberry.jpg"/>
              <p className={styles.author}>Photo by <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/@allecgomes?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Allec Gomes</a> on <a target="_blank" rel="noopener noreferrer" href="https://unsplash.com/s/photos/strawberry?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Unsplash</a></p>
            </div>
            <div className={styles.colRight}>
              <div className={styles.rowDescription}>
                <p className={styles.category}>과일</p>
                <p className={styles.title}>여름에는 딸기가 맛있어요!</p>
                <p className={styles.buy}><span className={styles.unit}>482</span>명의 사용자가 구매했습니다.</p>
                <hr className={styles.divider}/>
                <p className={styles.price}><del>6,590원<span className={styles.unit}>(100g당 659원)</span></del></p>
                <p className={styles.price}>여름 한정 3,295원<span className={styles.unit}>(100g당 329원)</span></p>
              </div>
              <div className={styles.rowAction}>
                <Button onClick={(e) => onCartClick(e) } className={styles.btnCart}>장바구니 담기</Button>
                <Button onClick={(e) => onBuyClick(e) } className={styles.btnBuy} type="primary">구매하기</Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  )
}